'use client';

import { useEffect } from 'react';
import { useParams } from 'next/navigation';
import { Button } from '@/components/ui/button';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const params = useParams();
  // Served home of the current country; '/' only when no country is in the URL.
  const home = params?.country ? `/${params.country}` : '/';
  useEffect(() => {
    console.error('BuyWisely error:', error);
  }, [error]);

  return (
    <div className="flex flex-col justify-center items-center px-4 min-h-[50vh]">
      <h2 className="text-xl font-semibold mb-2">Something went wrong</h2>
      <p className="text-sm text-muted-foreground mb-4">
        We hit an unexpected error. Please try again.
      </p>
      <div className="flex gap-2">
        <Button variant="outline" onClick={() => reset()}>
          Try again
        </Button>
        <Button asChild>
          <a href={home}>Go to homepage</a>
        </Button>
      </div>
    </div>
  );
}
